import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Modal from 'src/components/ui/Features/Modal/Modal';
import useFetch from 'src/hook/api/useFetch';
import useUser from 'src/hook/data/useUser';
import { HttpMethod, ResponseType } from 'src/model/enum/enums';
import { GetRazorSiteUrl, IconLocation, ImageLocation } from 'src/utils/URLUtils';
import styles from './AvatarModal.module.scss';
interface AvatarModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (value: boolean) => void;
}

const AvatarModal = ({ isModalOpen, setIsModalOpen }: AvatarModalProps) => {
    const { t } = useTranslation();
    const { userInfo, updateUserInfo } = useUser();
    const { send } = useFetch();

    const avatars = Array.from({ length: 20 }, (_, i) => i + 1);

    const handleAvatarSelect = (avatarId: number) => {
        const url = `${ImageLocation(`avatar/Avatar (${avatarId}).png`)}`;
        updateUserInfo({ ...userInfo, Avatar: url });
        setIsModalOpen(false);
        send(`${GetRazorSiteUrl(`settings/Avatar/Avatar (${avatarId})`, userInfo?.Token)}`,
            HttpMethod.POST,
            null,
            ResponseType.Text
        );
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
        >
            <div className={styles.avatarModal}>
                <div className={styles.header}>
                    <h2>{t('Choose your avatar')}</h2>
                    <img
                        src={IconLocation('x')}
                        className={styles.close}
                        alt={t('close')}
                        onClick={() => setIsModalOpen(false)}
                    />
                </div>
                <div className={styles.avatarGrid}>
                    {avatars.map((avatarId) => (
                        <img
                            key={avatarId}
                            src={`${ImageLocation(`avatar/Avatar (${avatarId}).png`)}`}
                            className={classNames(styles.avatarItem, {
                                [styles.selected]: userInfo?.Avatar === avatarId.toString()
                            })}
                            alt={t('Avatar {{id}}', { id: avatarId })}
                            onClick={() => handleAvatarSelect(avatarId)}
                        />
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default AvatarModal;